import * as React from 'react'

import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import { ExecutionElement } from '../flow/ExecutionElement'

import type * as Flows from '../../../shared/domain/flows/types.no-deps'
import { SVG_External_Link } from '../svg/SVG_External_Link'
import i18next from 'i18next'
import type { LoopPathIds } from '../../../shared/domain/flows/LoopPath.no-deps'
import { ElementOptionsIcon } from './ElementOptionsIcon'

interface Props {
    deps: CommonDeps
    elementId: Flows.ElementId
    loopPathIds: LoopPathIds
    description: string
    url: string
    openOptions?: () => void
}

export class ElementLink extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    private handleClick() {
        const newWindow = window.open(this.props.url, '_blank')
        // prevent 'tabnabbing' vulnerabilty
        // (https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/)
        newWindow.opener = null
    }

    private handleFeedbackIconClick = (event: React.MouseEvent) => {
        event.stopPropagation()

        this.props.openOptions()
    }

    private tryRender = () => {
        const { elementId, description, openOptions } = this.props

        return (
            <ExecutionElement
                deps={this.props.deps}
                elementId={elementId}
                loopPathIds={this.props.loopPathIds}
                validationMessages={[]}
            >
                <div className="AppCore__flow__ElementLink__Container" onClick={() => this.handleClick()}>
                    <div className="AppCore__flow__ElementLink__Main">
                        <div className="AppCore__flow__ElementLink">
                            <div className="AppCore__flow__ElementLink__link">
                                <p className="AppCore__flow__ElementLink__description">{description}</p>
                            </div>
                            <div className="AppCore__flow__ElementLink__iconExtLink">
                                <SVG_External_Link color="var(--grey3)" />
                            </div>
                        </div>
                        {openOptions && <ElementOptionsIcon openOptions={this.handleFeedbackIconClick} />}
                    </div>
                    <p>{i18next.t('appcore:element.link.info')}</p>
                </div>
            </ExecutionElement>
        )
    }
}
